'use client'

import * as React from 'react'
import { IconChevronRight } from '@repo/design-system-cf/components/icons'
import { Typography } from '@repo/design-system-cf/components/typography'
import { Breadcrumbs } from '@repo/web-ui/components/breadcrumbs'
import { SearchInput } from '@repo/design-system-cf/components/input'
import { useTranslations } from 'next-intl'

export function Header({
  count = 0,
  onSearch,
  title,
}: {
  count?: number
  onSearch?: (value: string) => void
  title: string
}) {
  const t = useTranslations('pages.fonts.header')
  const formattedCount = count ? `${count.toLocaleString()}+` : '0'
  const [value, setValue] = React.useState('')

  return (
    <div className="flex flex-col">
      <Breadcrumbs
        items={[
          {
            title: t('breadcrumbs.home'),
            path: '/',
          },
          {
            title: t('breadcrumbs.fonts'),
            path: '/fonts',
          },
          {
            title,
          },
        ]}
        separator={<IconChevronRight className="size-4" />}
      />
      <div className="flex flex-col items-center max-w-[1000px] mx-auto mt-[20px]">
        <Typography variant="cf-title-09" asChild className="text-center">
          <h1>{title}</h1>
        </Typography>
        <Typography
          variant="body-02"
          className="text-center mt-4 text-gray-600"
          data-testid="2-line-intro-text"
        >
          {t('description', { count: formattedCount, title: title.toLowerCase() })}
        </Typography>
        <SearchInput
          className="max-w-[700px] bg-cf-white shadow-md mt-6"
          value={value}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value)}
          onSearch={() => onSearch?.(value)}
          placeholder={t('search_placeholder', { count: formattedCount })}
          data-testid="fonts-search-input"
        />
      </div>
    </div>
  )
}
